// Shared formatting for the Expense Analysis module.

export function fmtMoney(v, { cents = true } = {}) {
  const n = Number(v || 0);
  return n.toLocaleString('en-US', {
    style: 'currency', currency: 'USD',
    minimumFractionDigits: cents ? 2 : 0,
    maximumFractionDigits: cents ? 2 : 0,
  });
}

// Compact form for axis labels and dense tiles: $1.2M / $84.2K.
export function fmtMoneyShort(v) {
  const n = Number(v || 0);
  const abs = Math.abs(n);
  const sign = n < 0 ? '-' : '';
  if (abs >= 1_000_000) return `${sign}$${(abs / 1_000_000).toFixed(abs >= 10_000_000 ? 0 : 1)}M`;
  if (abs >= 1_000)     return `${sign}$${(abs / 1_000).toFixed(abs >= 10_000 ? 0 : 1)}K`;
  return `${sign}$${abs.toFixed(0)}`;
}

export function fmtNumber(v) {
  return Number(v || 0).toLocaleString('en-US');
}

export function fmtPct(v, digits = 1) {
  return `${(Number(v || 0) * 100).toFixed(digits)}%`;
}

// Dates arrive as 'YYYY-MM-DD' — parse as local, not UTC, so a date never
// renders one day early in a negative-offset timezone.
export function fmtDate(v) {
  if (!v) return '—';
  const s = String(v).slice(0, 10);
  const [y, m, d] = s.split('-').map(Number);
  if (!y || !m || !d) return s;
  return new Date(y, m - 1, d).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
}

export function fmtMonth(ym) {
  if (!ym) return '—';
  const [y, m] = String(ym).split('-').map(Number);
  if (!y || !m) return ym;
  return new Date(y, m - 1, 1).toLocaleDateString('en-US', { month: 'short', year: 'numeric' });
}

export function monthLabelShort(ym) {
  if (!ym) return '';
  const [y, m] = String(ym).split('-').map(Number);
  return new Date(y, m - 1, 1).toLocaleDateString('en-US', { month: 'short' }) +
    (m === 1 ? ` '${String(y).slice(2)}` : '');
}
